import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dialog-footer" }

import { ref } from "vue";
import TopicService from "../../services/TopicService";
import notification from "@/core/plugins/notification";


export default /*#__PURE__*/_defineComponent({
  __name: 'SendTestEmailDialog',
  setup(__props, { expose: __expose }) {

const visible = ref(false);
const form = ref({
  testEmails: "kay.wu@bacera.com",
  topicId: "",
});

const isLoading = ref(false);

const sendTestEmail = async () => {
  isLoading.value = true;
  console.log(form.value);
  try {
    var unTrimmedEmailList = form.value.testEmails.split(",");
    var trimmedEmailList = unTrimmedEmailList
      .map((email) => email.trim())
      .filter((email) => email !== "");
    await TopicService.sendTestEmailBatchV2({
      testEmails: trimmedEmailList,
      topicId: form.value.topicId,
    });
    notification.success();
  } catch (e) {
    console.error(e);
  } finally {
    isLoading.value = false;
    visible.value = false;
  }
};

const handleClose = () => {
  visible.value = false;
};

const show = (item) => {
  visible.value = true;
  form.value.topicId = item.id;
};

__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
    title: "Send Test Emails",
    width: "60%",
    "before-close": handleClose
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createVNode(_component_el_button, {
          onClick: handleClose,
          plain: "",
          disabled: isLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: sendTestEmail,
          plain: "",
          loading: isLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.send")), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        model: form.value,
        "label-width": "120px",
        "label-position": "top"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, { label: "Emails" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: form.value.testEmails,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.testEmails) = $event)),
                disabled: isLoading.value,
                type: "textarea",
                autosize: { minRows: 2, maxRows: 4 }
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})